<div class="container-fluid h-100">
  <div class="row h-100 ">
    <div class="col-auto bg-white h-100">
      <Sidebar ref="sidebar"></Sidebar>
    </div>
    <div class="col bg-white h-100">
      <Navbar @toggle-sidebar="toggleSidebar"></Navbar>
      <div class="bg-gray px-4 py-1 h-100 scrollable-container">
        <div class="card bg-white shadow-sm mt-5 rounded-5 border-0">
          <!-- Card Header -->
          <div class="card-header bg-white border-0 rounded-5 d-flex justify-content-between align-items-center mt-3">
            <div class="d-flex gap-2">
              <button class="btn btn-warning text-white text-xs rounded-3 shadow-lg fw-500" data-bs-toggle="modal"
                data-bs-target="#assign_position">
                <i class='bx bx-plus'></i> Assign Roles
              </button>
              <button class="btn btn-warning text-white text-xs rounded-3 shadow-lg fw-500" data-bs-toggle="modal"
                data-bs-target="#create_position">
                <i class='bx bx-plus'></i> Create Role
              </button>
            </div>
          </div>

          <!-- Card Body -->
          <div class="card-body bg-light">
            <!-- Create Position Modal -->
            <div class="modal fade" id="create_position" tabindex="-1" aria-labelledby="create_positionModalLabel"
              aria-hidden="true">
              <div class="modal-dialog modal-lg">
                <div class="modal-content">
                  <div class="modal-header">
                    <p class="modal-title text-xs fw-500" id="exampleModalLabel">Create a Position</p>
                    <button type="button" class="btn-close text-xs fw-500" data-bs-dismiss="modal"
                      aria-label="Close"></button>
                  </div>
                  <form @submit.prevent="create_role">
                    <div class="modal-body">
                      <div class="mb-3">
                        <label for="position_name" class="form-label text-xs fw-500">
                          Position Name <span class="text-danger">*</span>
                        </label>
                        <input type="text" class="form-control rounded-5 text-xs" id="position_name"
                          placeholder="Enter position name" v-model="position_name">
                        <p v-if="errors.position_name" class="text-danger text-xs">{{ errors.position_name }}</p>
                      </div>
                    </div>
                    <div class="modal-footer">
                      <button type="submit" class="btn btn-primary text-xs rounded-5">Post</button>
                    </div>
                  </form>
                </div>
              </div>
            </div>

            <!-- Roles Table -->
            <div class="table-responsive table-scroll">
              <table id="roles_table" class="table  align-middle table-borderless table-striped mb-0">
                <thead class="text-white text-uppercase small bg-dark sticky-top text-xxs">
                  <tr>
                    <th class="text-center"></th>
                    <th class="text-center">Portal Roles</th>
                    <th class="text-center">Actions</th>
                  </tr>
                </thead>
                <tbody class="text-xxs">
                  <tr v-for="(position, index) in positions" :key="position.id" class="border-bottom">
                    <td class="text-center">
                      <span class="badge rounded-pill bg-primary text-white fw-normal px-2 py-1 small">
                        {{ index + 1 }}
                      </span>
                    </td>
                    <td class="text-center">{{ position.name }}</td>
                    <td class="text-center">
                      <div class="d-flex justify-content-center gap-1">
                        <button class="btn btn-light btn-sm rounded-3 text-success border shadow-sm"
                          data-bs-toggle="modal"
                          :data-bs-target="'#edit_position_' + position.id"
                          @click="editpositionName(position)">
                          Edit
                        </button>
                        <button @click="deleteposition(position.id)"
                          class="btn btn-light btn-sm rounded-3 text-danger border shadow-sm">
                          Delete
                        </button>
                      </div>
                    <div class="modal fade" :id="'edit_position_' + position.id" tabindex="-1"
                    :aria-labelledby="edit_position_ + position.id + 'Label'" aria-hidden="true">
                    <div class="modal-dialog modal-lg">
                      <div class="modal-content">
                        <div class="modal-header">
                          <p class="modal-title text-xs fw-500" id="exampleModalLabel">Edit position</p>
                          <button type="button" class="btn-close text-xs fw-500" data-bs-dismiss="modal"
                            aria-label="Close"></button>
                        </div>
                        <form @submit.prevent="edit_portal_position(position)">
                          <div class="modal-body">

                            <div class="mb-3">
                              <label :for="'edit_position_name_' + position.id" class="form-label text-xs fw-500">position Name <span
                                  class="text-danger">*</span></label>
                              <input type="text" class="form-control rounded-5 text-xs"
                              :id="'edit_position_name_' + position.id" v-model="edit_position">
                              <p v-if="errors.position_name" class="text-danger text-xs">{{ errors.position_name }}</p>
                            </div>

                          </div>
                          <div class="modal-footer">
                            <button type="submit" class="btn btn-primary text-xs rounded-5">Post</button>
                          </div>
                        </form>
                      </div>
                    </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <!-- Assign Position Modal -->
          <div class="card-body table-responsive">
            <div class="modal fade" id="assign_position" tabindex="-1" aria-labelledby="assignPositionModalLabel" aria-hidden="true">
              <div class="modal-dialog modal-lg">
                <div class="modal-content">
                  <div class="modal-header">
                    <p class="modal-title text-xs fw-500" id="assignPositionModalLabel">Assign Position</p>
                    <button type="button" class="btn-close text-xs fw-500" data-bs-dismiss="modal" aria-label="Close"></button>
                  </div>
                  <form @submit.prevent="assignPosition">
                    <div class="modal-body">
                      <table class="table table-striped text-xs mt-3">
                        <thead class="btn-primary text-white">
                          <tr>
                            <th scope="col"></th>
                            <th scope="col">Portal name</th>
                            <th scope="col">Assign Roles</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(portal, index) in portals" :key="portal.id">
                            <th scope="row">{{ index + 1 }}</th>
                            <td id="portal_id">{{ portal.name }}</td>
                            <td>
                              <div class="mb-3">
                                <div v-if="portal.positions.length">
                                  <span v-for="(pos, posIndex) in portal.positions" :key="pos.id"
                                    class="badge bg-primary text-white me-1">
                                    {{ pos.name }}
                                    <button type="button" class="btn-primary btn-close ms-1"
                                      aria-label="Remove"
                                      @click="remove_position(pos.id, portal.id,posIndex)">
                                    </button>
                                  </span>
                                </div>
                                <select class="form-control text-xs mt-2"
                                  @click="assign_position_to_portal($event, portal.id)">
                                  <option value="">Select a position</option>
                                  <option v-for="pos in availablePositions(portal)"
                                    :key="pos.id" :value="pos.id">
                                    {{ pos.name }}
                                  </option>
                                </select>

                                <datalist id="positionsList">
                                  <option v-for="pos in all_positions" :key="pos.id" :value="pos.name"
                                  ></option>
                                </datalist>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
</div>